<template>
  <form-wrapper>
    <b-form @submit="submit">
      <h2 class="text-center">
        Create a new topic
      </h2>
      <b-form-group>
        <label for="name-input">Name</label>
        <b-form-input
          v-validate="'required'"
          id="name-input"
          :disabled="saving"
          :class="{ 'is-invalid' : errors.has('name') || apiErrors.name.length }"
          :value="fields.name"
          class="form-control"
          type="text"
          name="name"
          @input="setName"/>
        <validation-errors :validation-errors="[errors.first('name')]"/>
        <validation-errors v-if="!errors.has('name')" :validation-errors="apiErrors.name"/>
      </b-form-group>

      <b-form-group>
        <label for="description-input">Description</label>
        <b-form-textarea
          v-validate="'required'"
          id="description-input"
          :disabled="saving"
          :class="{ 'is-invalid' : errors.has('description') || apiErrors.description.length }"
          :rows="3"
          :max-rows="6"
          :value="fields.description"
          type="text"
          name="description"
          @input="setDescription"/>
        <validation-errors :validation-errors="[errors.first('description')]"/>
        <validation-errors v-if="!errors.has('description')" :validation-errors="apiErrors.description"/>
      </b-form-group>

      <b-form-group class="form-buttons">
        <b-button :disabled="disabled" type="submit" variant="primary">
          Confirm
          <span v-if="saving"><i class="fas fa-spinner fa-spin"></i></span>
        </b-button>
      </b-form-group>

      <form-success :success="success" class="form-alert">
        Topic Created!
      </form-success>
    </b-form>

  </form-wrapper>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import formSuccess from '../../../common/form/form-success'
import formWrapper from '../../../common/form/form-wrapper'
import validationErrors from '../../../common/form/validation-errors'

export default {
  components: {
    formSuccess,
    formWrapper,
    validationErrors
  },
  computed: {
    ...mapState('topics/forms/store', [
      'apiErrors',
      'fields',
      'success',
      'saving'
    ]),
    ...mapState('topics', {
      topic: 'current'
    }),
    ...mapState('config', {
      apiConfig: 'data'
    }),
    disabled () {
      return this.errors.any() || this.saving
    }
  },
  watch: {
    success (newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.resetFields()
      }
    }
  },
  methods: {
    ...mapActions({
      storeTopic: 'topics/store'
    }),
    submit (event) {
      event.preventDefault()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.storeTopic()
        }
      })
    },
    setName (event) {
      this.$store.commit('topics/forms/store/setField', {
        field: 'name',
        value: event
      })
    },
    setDescription (event) {
      this.$store.commit('topics/forms/store/setField', {
        field: 'description',
        value: event
      })
    },
    reset (event) {
      this.errors.clear()
    },
    resetFields (event) {
      this.reset()
      this.$store.commit('topics/forms/store/resetFields')
    },
    resetForm (event) {
      this.reset()
      this.$store.commit('topics/forms/store/resetState')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/topics/add.vue